import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { Plus } from "lucide-react";
import { CreateApiKeyModal } from "./CreateApiKeyModal";
import { Button } from "@/components/ui";
export const AddApiKeySection = ({ onCreateApiKey, onModalClose, isLoading, products, defaultProductCode, productsLoading })=>{
    const [showCreateModal, setShowCreateModal] = useState(false);
    const handleModalClose = ()=>{
        setShowCreateModal(false);
        if (onModalClose) {
            onModalClose();
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Button, {
                variant: "simple",
                color: "navy-90",
                className: "inline-flex items-center",
                onClick: ()=>setShowCreateModal(true),
                disabled: isLoading,
                children: [
                    /*#__PURE__*/ _jsx(Plus, {
                        className: "mr-2 h-4 w-4"
                    }),
                    "Create API Key"
                ]
            }),
            /*#__PURE__*/ _jsx(CreateApiKeyModal, {
                isOpen: showCreateModal,
                onClose: handleModalClose,
                onSubmit: onCreateApiKey,
                isLoading: isLoading,
                products: products,
                defaultProductCode: defaultProductCode,
                productsLoading: productsLoading
            })
        ]
    });
};
